import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { UserJobStatus, useCafJobStatus } from '../../../modules/apis/student/lesson'
import { useCustomerType } from '../../../modules/apis/student/products'
import {
  useCafOverviewCancelPopupV5,
  useCafSummaryCancelPopupV5,
  useEditJobBannerV4,
  useShowJobBannerV4,
} from '../../../modules/apis/webview/caf'
import { useCurrentUser } from '../../../modules/context/UserContext'
import StackedBanner from '../StackedBanner'
import CafJobAnalysisEncouragementBox from './CafJobAnalysisEncouragementBox'
import LessonEncouragementBox from './LessonEncouragementBox'

interface CafBannerProps {
  pageType: 'review' | 'statistic' | 'myRingle'
  lessonBannerShow?: boolean
  lessonBannerType?: number
}

const CafBanner = ({ pageType, lessonBannerShow = false, lessonBannerType }: CafBannerProps) => {
  const { currentUser } = useCurrentUser()
  const { data: customerType } = useCustomerType()
  const [banners, setBanners] = useState<React.ReactNode[]>([])
  const [count, setCount] = useState(1)
  const [totalBannerCount, setTotalBannerCount] = useState(0)

  const router = useRouter()
  const lessonId = router.query?.lessonId || 0
  const { mutate: mutateCloseLessonBannerInReview } = useCafOverviewCancelPopupV5(+lessonId)
  const { mutate: mutateCloseLessonBannerInStatistic } = useCafSummaryCancelPopupV5()
  const { data: jobBannerShow } = useShowJobBannerV4('job_analysis_banner', pageType, +lessonId)
  const { data: jobStatus } = useCafJobStatus()
  const { mutate: mutateCloseJobBanner } = useEditJobBannerV4()

  const key = () => {
    if (pageType === 'review') {
      return `caf_${pageType}_${lessonId}_job_analysis_banner`
    } else if (pageType === 'statistic' || pageType === 'myRingle') {
      return `caf_${pageType}_job_analysis_banner`
    } else {
      // TODO: 에러 발생 시키기
      console.log('===== error occurred while making job_analysis_banner key')
      return
    }
  }

  const onCloseCafJobAnalysis = async () => {
    setCount((prev) => prev + 1)

    mutateCloseJobBanner(
      { key: key(), value: false },
      {
        onSuccess: () => {
          console.log('===== JobBanner is set to hidden')
        },
      }
    )
  }

  const onCloseLesson = async () => {
    setCount((prev) => prev + 1)
    if (pageType === 'review') {
      mutateCloseLessonBannerInReview()
    } else if (pageType === 'statistic') {
      mutateCloseLessonBannerInStatistic()
    } else {
      console.log('===== error in onCloseLesson logic')
    }
  }

  const bannerOptions = [
    <CafJobAnalysisEncouragementBox key={1} page={pageType} onClose={onCloseCafJobAnalysis} />,
    <LessonEncouragementBox
      key={2}
      page={pageType === 'review' ? 'review' : 'statistic'}
      popupType={lessonBannerType}
      onClose={onCloseLesson}
    />,
  ]

  const isBannerVisible = (item) => {
    if (item.key === '1') {
      if (jobStatus === UserJobStatus.SHOW) return false
      if (jobBannerShow.value === 'false') return false
      else return true
    } else if (item.key === '2') {
      return lessonBannerShow
    }
    console.log('=========error in logic of banner')
    return true
  }

  useEffect(() => {
    if (jobStatus && jobBannerShow) {
      const initBanners = bannerOptions.filter((item) => {
        return isBannerVisible(item)
      })

      setTotalBannerCount(initBanners.length)
      setBanners(initBanners)
    }
  }, [jobStatus, jobBannerShow, lessonBannerShow])

  if (customerType?.isMulticampus) return <></>

  if (totalBannerCount > 0 && count <= totalBannerCount)
    return (
      <div
        className={`flex w-full ${
          pageType === 'myRingle' ? 'mt-[16px]' : pageType === 'review' ? 'mb-[16px] sm:mb-[32px]' : 'mb-[24px] sm:m-0'
        } `}
      >
        <StackedBanner banners={banners} count={count} totalBannerCount={totalBannerCount} />
      </div>
    )
  else return null
}

export default CafBanner
